import { useTranslation } from 'react-i18next'

import { useProject } from '../../api/project'
import { useProjectId } from '../../hooks/useProjectId'

export const ArchivedProjectCheck = ({ children }) => {
  const { t } = useTranslation()
  const { data: project } = useProject(useProjectId())

  if (project?.status === 'ARCHIVED') {
    return <h1>{t('Project is archived')}</h1>
  }
  return children
}
